import React, {PropTypes}             from 'react';
import { Link }                       from 'react-router';
import { isLocal, isMobile, isIpad }  from 'utils/util';
import { get }                        from 'lodash';


export default React.createClass({
  displayName: 'MedscapeTV.TitleBar',
  propTypes: {
    chapters: PropTypes.array,
       index: PropTypes.number
  },
  componentDidMount() {
    if(isMobile() && !isIpad()) {
      document.querySelector('.hero-bg').style.height = (document.getElementById('medscape-tver').getBoundingClientRect().height + 20) + 'px';
    }
  },
  render() {
    const basePath = isLocal()? '': `/mtv/${window.MedscapeTVInstance.seriesUrlFragment}`,
          videoUrlFragment = get(window, 'MedscapeTVInstance.videos[0].videoUrlFragment', '/');
    return (
      <div className="episode-guide">
        <div className="ep-guide-overlay">
          <div className="ep-guide">
            <div className="title1">{ get(window, 'MedscapeTVInstance.specialtyTitle', '') }</div>
            <div className="title2">{ get(window, 'MedscapeTVInstance.seriesTitle', '') }</div>
            <div className="desc">{ get(window, 'MedscapeTVInstance.seriesSummary', '') }</div>
            <div className="ep-buttons">
              <Link className="episode" to={`${basePath}/${videoUrlFragment}`}><span className="episode">Episode 1</span></Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/episode_guide.jsx
 **/